import React, { Component } from "react";
import "./index.css";
import BsyIconBtn from "../BsyIconBtn";

class AlertList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: React.language("prompt1"),
      msg: React.language("Export.tip", { name: React.language("allMember") }),
      type: "query",
      text4Ok: React.language("ok"),
      OkType: "red",
      maxLength: null,
      text4Cancel: React.language("cancel"),
      checkOkStatus: true,
    };
    if (
      this.props.type === "input" ||
      this.props.type === "error-input" ||
      this.props.type === "noIconInput"
    ) {
      this.inputref = React.createRef();
      this.state.checkOkStatus = false;
    }
  }

  closeAlter = () => {
    this.props.onRemoveRoot();
  };

  cancelClick = () => {
    const { cancel } = this.props;
    if (cancel) {
      let ret = true;
      ret = cancel();
      if (ret !== false) this.closeAlter();
    } else {
      this.closeAlter();
    }
  };
  okClick = () => {
    const { ok, type } = this.props;
    const { checkOkStatus } = this.state;
    if (ok) {
      if (!checkOkStatus) {
        return;
      }
      let ret = true;
      if (
        type === "input" ||
        type === "error-input" ||
        type === "noIconInput"
      ) {
        ret = ok(this.inputref.current.value, this.inputref.current);
      } else {
        ret = ok();
      }
      if (ret !== false) this.closeAlter();
    } else {
      this.closeAlter();
    }
  };

  changeInput = (event) => {
    if (this.props.onInputValidate) {
      let ret = this.props.onInputValidate(event.target.value);
      this.setState(
        {
          checkOkStatus: ret,
        },
        () => {
          if (ret) {
            event.target.classList.remove("error");
          } else {
            event.target.classList.add("error");
          }
        }
      );
    } else {
      event.target.classList.remove("error");
    }
  };

  getBody = () => {
    const {
      styleCss,
      title,
      msg,
      type,
      text4Ok,
      text4Cancel,
      OkType,
      value,
      placeholder,
      closeBtn,
      maxLength,
      iconColor,
      okColor,
    } = this.props;

    switch (type) {
      case "input": {
        return (
          <div className={"content " + window.mode} style={styleCss}>
            {closeBtn && (
              <div className="close" onClick={this.closeAlter}>
                <i className="icon-close-large"></i>
              </div>
            )}
            <div className="alertHeader">
              <div className="alertIcon">
                <i className={"icon-alert-" + type} />
              </div>
              <div className="alertText">
                <div className="alertTitle">{title}</div>
                {
                  msg && <div
                    className="alertMsg"
                    dangerouslySetInnerHTML={{ __html: msg }}
                  ></div>
                }
                <div className="alertInput">
                  <input
                    onChange={this.changeInput}
                    type="text"
                    maxLength={maxLength}
                    defaultValue={value}
                    placeholder={placeholder}
                    ref={this.inputref}
                  />
                </div>
              </div>
            </div>
            <div className="alertFooter">
              {text4Cancel ? (
                <BsyIconBtn
                  text={text4Cancel}
                  click={this.cancelClick}
                  type="white"
                  mode={window.mode}
                />
              ) : (
                ""
              )}
              <BsyIconBtn
                key={"ok" + new Date().getTime()}
                enable={this.state.checkOkStatus}
                text={text4Ok}
                click={this.okClick}
                type={OkType}
                mode={window.mode}
              />
            </div>
          </div>
        );
      }
      case "noIconInput": {
        return (
          <div className={"content " + window.mode} style={styleCss}>
            {closeBtn && (
              <div className="close" onClick={this.closeAlter}>
                <i className="icon-close-large"></i>
              </div>
            )}
            <div className="alertHeader">
              <div
                className="alertText"
                style={{ "padding-left": 0, "margin-left": 0 }}
              >
                <div className="alertTitle">{title}</div>
                {
                  msg && <div
                    className="alertMsg"
                    dangerouslySetInnerHTML={{ __html: msg }}
                  ></div>
                }
                <div className="alertInput">
                  <input
                    onChange={this.changeInput}
                    type="text"
                    maxLength={maxLength}
                    defaultValue={value}
                    placeholder={placeholder}
                    ref={this.inputref}
                  />
                </div>
              </div>
            </div>
            <div className="alertFooter">
              {text4Cancel ? (
                <BsyIconBtn
                  text={text4Cancel}
                  click={this.cancelClick}
                  type="white"
                  mode={window.mode}
                />
              ) : (
                ""
              )}
              <BsyIconBtn
                key={"ok" + new Date().getTime()}
                enable={this.state.checkOkStatus}
                text={text4Ok}
                click={this.okClick}
                type={OkType}
                mode={window.mode}
              />
            </div>
          </div>
        );
      }
      case "error-input": {
        return (
          <div className={"content " + window.mode} style={styleCss}>
            {closeBtn && (
              <div className="close" onClick={this.closeAlter}>
                <i className="icon-close-large"></i>
              </div>
            )}
            <div className="alertHeader">
              <div className="alertTop">
                <div className="alertIcon">
                  <i className={"icon-alert-warning"} />
                </div>
                <div className="alertTitle">{title}</div>
              </div>
              <div className="alertText">
                {
                  msg && <div
                    className="alertMsg"
                    dangerouslySetInnerHTML={{ __html: msg }}
                  ></div>
                }

                <div className="alertInput">
                  <input
                    onChange={this.changeInput}
                    type="text"
                    maxLength={maxLength}
                    defaultValue={value}
                    placeholder={placeholder}
                    ref={this.inputref}
                  />
                </div>
              </div>
            </div>
            <div className="alertFooter">
              {text4Cancel ? (
                <BsyIconBtn
                  text={text4Cancel}
                  click={this.cancelClick}
                  type="white"
                  mode={window.mode}
                />
              ) : (
                ""
              )}
              <BsyIconBtn
                key={"ok" + new Date().getTime()}
                enable={this.state.checkOkStatus}
                text={text4Ok}
                click={this.okClick}
                type={OkType}
                mode={window.mode}
              />
            </div>
          </div>
        );
      }
      case "info": {
        return (
          <div className={"content " + window.mode} style={styleCss}>
            {closeBtn && (
              <div className="close" onClick={this.closeAlter}>
                <i className="icon-close-large"></i>
              </div>
            )}
            <div className="alertHeader">
              <div className="alertText">
                <div className="alertTitle">{title}</div>
                {
                  msg && <div
                    className="alertMsg"
                    dangerouslySetInnerHTML={{ __html: msg }}
                  ></div>
                }
              </div>
            </div>
            <div className="alertFooter">
              {text4Cancel ? (
                <BsyIconBtn
                  text={text4Cancel}
                  click={this.cancelClick}
                  type="white"
                  mode={window.mode}
                />
              ) : (
                ""
              )}

              <BsyIconBtn
                text={text4Ok}
                click={this.okClick}
                type={OkType}
                mode={window.mode}
              />
            </div>
          </div>
        );
      }
      default: {
        return (
          <div className={"content " + window.mode} style={styleCss}>
            {closeBtn && (
              <div className="close" onClick={this.closeAlter}>
                <i className="icon-close-large"></i>
              </div>
            )}
            <div className="alertHeader">
              <div className="alertTop">
                <div className="alertIcon">
                  <i
                    style={{ color: iconColor }}
                    className={"icon-alert-" + type}
                  />
                </div>
                <div className="alertTitle">{title}</div>
              </div>
              <div className="alertText">
                {
                  msg && <div
                    className="alertMsg"
                    dangerouslySetInnerHTML={{ __html: msg }}
                  ></div>
                }
              </div>
            </div>
            <div className="alertFooter">
              {text4Cancel ? (
                <BsyIconBtn
                  text={text4Cancel}
                  click={this.cancelClick}
                  type="white"
                  mode={window.mode}
                />
              ) : (
                ""
              )}
              <BsyIconBtn
                text={text4Ok}
                click={this.okClick}
                textColor={okColor}
                type={OkType}
                mode={window.mode}
              />
            </div>
          </div>
        );
      }
    }
  };

  render() {
    // const { styleCss, title, msg, type, text4Ok, text4Cancel, OkType } = this.props
    return <React.Fragment> {this.getBody()}</React.Fragment>;
  }
}

export default AlertList;
